import { TranslateService } from '@ngx-translate/core';
//import { Observable } from 'rxjs/Observable';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { ItemAction } from 'app/buffer-graph/models/item-actions/item-action';
import { FreshItemActionHeader } from 'app/buffer-graph/models/item-actions/fresh-item-action-header';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {Moment} from "moment";
import {ItemInfo} from "../item-info";

type Action = ItemAction | FreshItemActionHeader;
type Data = { actions: Action[], isFresh: boolean, sku: string, warehouseCode: string, canSend: boolean, columns: ColumnSettingsBase[], columnsLine: ColumnSettingsBase[], isAll?: boolean };

export class ItemActionsTabInfo extends TabInfoBase<Data> {
    constructor(type: string, zoomFieldDate: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super('Actions', type, zoomFieldDate, data, itemInfo, startDate, endDate, sharedGuid);
    }

    get id(): string {
        return ItemActionsTabInfo.id;
    }

    static readonly id = 'IA';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/item-actions-tab-info.ts